import React from 'react';
import Button from '../../../components/ui/Button';

const NotificationBulkActions = ({
  totalUnread,
  totalNotifications,
  deletableCount,
  pendingLicenseInvites = 0,
  onMarkAllAsRead,
  onClearAll,
}) => {
  if (totalNotifications === 0) return null;

  const clearDisabled = deletableCount === 0;

  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap items-stretch sm:items-center gap-2 sm:gap-3">
      {totalUnread > 0 && (
        <p className="text-sm text-muted-foreground sm:mr-1">
          <span className="font-semibold text-foreground tabular-nums">
            {totalUnread}
          </span>{' '}
          {totalUnread === 1 ? 'não lida' : 'não lidas'}
        </p>
      )}

      <div className="flex flex-wrap items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="CheckCheck"
          iconPosition="left"
          onClick={onMarkAllAsRead}
          disabled={totalUnread === 0}
        >
          Marcar todas como lidas
        </Button>

        <Button
          variant="ghost"
          size="sm"
          iconName="Trash2"
          iconPosition="left"
          className="text-muted-foreground hover:text-destructive"
          onClick={onClearAll}
          disabled={clearDisabled}
          title={
            clearDisabled && pendingLicenseInvites > 0
              ? 'Convites de licença pendente não podem ser excluídos'
              : undefined
          }
        >
          Limpar todas
        </Button>
      </div>
    </div>
  );
};

export default NotificationBulkActions;
